<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import BrandUsp from './BrandUsp/BrandUsp.vue'

const { t } = useI18n()
</script>

<template>
  <div class="brand-usps">
    <BrandUsp class="brand-usps__usp brand-usps__first">
      {{ t('home_header.component_bistroo_usps.usp_1') }}
    </BrandUsp>
    <BrandUsp class="brand-usps__usp">
      {{ t('home_header.component_bistroo_usps.usp_2') }}
    </BrandUsp>
    <BrandUsp class="brand-usps__usp">
      {{ t('home_header.component_bistroo_usps.usp_3') }}
    </BrandUsp>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/css/mixins/breakpoints-up.scss";
@import "@/assets/css/mixins/breakpoints-down.scss";

.brand-usps {
  display:  flex;
  justify-content: center;
  gap:      1.5rem;
  position: relative;

  &__usp {
    width: 50%;
  }

  &__first {
    @include lg-down {
      opacity: 0;
      width: 0;
    }
  }

  &:deep(.b-icon-icon svg) {
    width: 18px;
    height: 18px;

    @include lg-up {
      width: 20px;
      height: 20px;
    }
  }

  @include lg-up {
    justify-content: flex-start;

    &__usp {
      max-width: 180px;
      z-index: 1;

      &:first-child {
        transform: translateY(5px);
      }

      &:nth-child(2) {
        transform: translateY(20px);
      }

      &:last-child {
        transform: translateY(10px);
      }
    }

    &::before {
      content:          "";
      pointer-events:   none;
      left:             -200px;
      top:              -205px;
      position:         absolute;
      z-index:          0;
      width:            1760px;
      height:           402px;
      background-image: url("/assets/img/homepage/header/usps-dotted-line.svg");
      background-repeat: no-repeat;

      @include xxl-up {
        width: 200%;
      }

      @include xxxl-up {
        width: 140%;
      }
    }
  }
}
</style>
